import { render, staticRenderFns } from "./ClientSummary.vue?vue&type=template&id=7e037f04"
import script from "./ClientSummary.vue?vue&type=script&lang=js"
export * from "./ClientSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports